module.exports = __webpack_public_path__ + "signature.png?4b56cb073e7086622a0da6ae1d8f9542";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aupair/signature.png
// module id = 308
// module chunks = 0